/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { HeaderWithBottomLine } from "../HeaderWithBottomLine";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Select,
  Spin,
  message,
  Radio,
} from "antd";
import FormComponent from "../../../../components/FormComponent";

import {
  checkSpace,
  checkSpecialCharacter,
  checkNumbervalue,
} from "../../../../utils";
import { patchOnboardForm } from "../../../../actionsMethods/masterMethods";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useLocation, useNavigate } from "react-router";

function MiscellaneousDetails({
  screen,
  goToViewCp,
  currentScreen,
  check,
  apiResponse,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [ownVehicle, setOwnVehicle] = useState(false);
  const radioGap = {
    display: "flex",
    columnGap: "4rem",
  };

  useEffect(() => {
    setOwnVehicle(apiResponse?.premiseDto?.mineHubConnected);
  }, [apiResponse]);
  const [form] = Form.useForm();
  const history = useLocation();

  let userData = JSON.parse(localStorage.getItem("userinfo"));

  const { error, result, fetching } = useSelector(
    (state) => state.masterReducer.patchOnboardFormReducer,
    shallowEqual
  );

  useEffect(() => {
    form.resetFields();
  }, [check]);

  useEffect(() => {
    if (
      result !== null &&
      result?.miscellaneousDto["experienceInCourierIndustry"] !== null &&
      currentScreen === 3
    ) {
      let temp = {
        ...history?.state,
        premiseDetails: { ...result?.cpDetails?.premiseDetails },
        miscellaneousDetails: { ...result?.cpDetails?.miscellaneousDetails },
        screen: 3,
      };

      navigate("", {
        state: temp,
      });
      screen(4);
    }
    if (error !== null && currentScreen === 3) {
      message.error(error.message || "Something went wrong");
    }
  }, [fetching]);

  let miscellaneousInitialValues = {
    Experience: apiResponse?.miscellaneousDto?.experienceInCourierIndustry,
    previousCompany: apiResponse?.miscellaneousDto?.previousCourierCompanyName,
    MonthlyTurnover: apiResponse?.miscellaneousDto?.monthlyTurnover,
    OwnerShip: apiResponse?.miscellaneousDto?.officeOwnership,
    officeArea: apiResponse?.miscellaneousDto?.officeArea,
    staff: apiResponse?.miscellaneousDto?.noOfStaff,
    checkVehicleAvailability:
      apiResponse?.miscellaneousDto?.checkVehicleAvailability,
    numberOfVehicles: apiResponse?.miscellaneousDto?.numberOfVehicles,
  };

  useEffect(() => {
    if (apiResponse) {
      form.setFieldsValue(miscellaneousInitialValues);
    }
  }, [apiResponse]);

  const onSubmitFormData = (values) => {
    let cloneData = { ...history?.state?.premiseDetails };
    delete cloneData.emailId;

    let data2 = {
      miscellaneousDetailsDto: {
        experienceInCourierIndustry: +values?.Experience,
        previousCourierCompanyName: values?.previousCompany,
        monthlyTurnover: +values?.MonthlyTurnover,
        officeOwnership: values?.OwnerShip,
        officeArea: values?.officeArea,
        noOfStaff: +values?.staff,
        checkVehicleAvailability: values?.checkVehicleAvailability,
        numberOfVehicles: values?.numberOfVehicles,
      },
    };

    dispatch(
      // patchOnboardForm(data2, userData?.emailId, history?.state?.premiseId)
      patchOnboardForm(data2, userData?.userName, apiResponse?.premiseId)

      // patchOnboardForm(data2, history?.state?.premiseDetails?.premiseId)
    );
  };

  const formProps = {
    name: "MiscellaneousDetails",
    className: "register-form",
    initialValues: {
      //   layout: formLayout,
    },
    onFinish: onSubmitFormData,
    autoComplete: "off",
  };
  const formLayout = "vertical";

  const backPage = () => {
    screen(2);
  };
  let preFiledData = history?.state?.miscellaneousDetails;

  let lg = 12;
  let sm = 12;
  let md = 12;
  let xs = 24;

  function validateInput(rule, value, callback) {
    if (/^\s/.test(value)) {
      callback("Input cannot start with a space!");
    } else {
      callback();
    }
  }

  return (
    <Spin spinning={fetching}>
      <div>
        <div className="form-contener">
          <div className="form-contener-inner">
            <div className="form-contener-priview">
              <FormComponent
                formProps={formProps}
                formLayout={formLayout}
                form={form}
                initialValues={{
                  Experience: preFiledData?.experienceInCourierIndustry,
                  previousCompany: preFiledData?.previousCourierCompanyName,
                  MonthlyTurnover: preFiledData?.monthlyTurnover,
                  OwnerShip: preFiledData?.officeOwnership,
                  officeArea: preFiledData?.officeArea,
                  staff: preFiledData?.noOfStaff,
                }}
              >
                <HeaderWithBottomLine
                  text={"Miscellaneous Details"}
                  icon={false}
                />
                <Row
                  gutter={40}
                  className="basic-details-conten global-form-row"
                >
                  <Col lg={lg} md={md} sm={sm} xs={xs}>
                    <Form.Item
                      name="Experience"
                      label={"Experience in courier industry (in years)"}
                      onKeyPress={(event) => {
                        if (checkNumbervalue(event) || checkSpace(event)) {
                          event.preventDefault();
                        }
                      }}
                      rules={[
                        {
                          pattern: /^[0-9].*/g,
                          message: "Initial value should be numeric.",
                        },
                        {
                          pattern: /^\d{1,2}(\.\d{0,2})?$/,
                          message: "Invalid experience",
                        },
                      ]}
                    >
                      <Input
                        placeholder="0"
                        type="text"
                        maxLength={5}
                        onKeyPress={(e) => {
                          if (/[^0-9.]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} md={md} sm={sm} xs={xs}>
                    <Form.Item
                      name="previousCompany"
                      label={"Name of the previous courier company"}
                    >
                      <Input
                        placeholder="Enter previous company name"
                        type="text"
                        maxLength={50}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} md={md} sm={sm} xs={xs}>
                    <Form.Item
                      name="MonthlyTurnover"
                      label={"Monthly turnover (approximate)"}
                      onKeyPress={(event) => {
                        if (checkNumbervalue(event) || checkSpace(event)) {
                          event.preventDefault();
                        }
                      }}
                      // rules={[
                      //   {
                      //     pattern: /^\d{1,10}(\.\d{0,2})?$/,
                      //     message: "Invalid turnover",
                      //   },
                      //   { validator: validateInput },

                      //   // () => ({
                      //   //   validator(rule, value = "") {
                      //   //     if (value.substring(1, 0) === " ") {
                      //   //       return Promise.reject("Invalid turnover");
                      //   //     } else {
                      //   //       return Promise.resolve();
                      //   //     }
                      //   //   },
                      //   // }),
                      // ]}
                    >
                      <Input placeholder="0" type="text" maxLength={20} />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} md={md} sm={sm} xs={xs}>
                    <Form.Item
                      name="OwnerShip"
                      label={
                        <span className="calculater-container-pikpin">
                          Office ownership
                        </span>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please select value",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select ownership"
                        options={[
                          {
                            value: "Owned",
                            label: "Owned",
                          },
                          {
                            value: "Rented",
                            label: "Rented",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} md={md} sm={sm} xs={xs}>
                    <Form.Item
                      name="officeArea"
                      label={"Office area in sq. ft."}
                      onKeyPress={(event) => {
                        if (checkNumbervalue(event) || checkSpace(event)) {
                          event.preventDefault();
                        }
                      }}
                      rules={[
                        {
                          required: true,
                          message: "Please enter value",
                        },
                        // {
                        //   pattern: /^[0-9]{1,3}(\.[0-9]{1,2})?$/g,
                        //   message: "Invalid office area",
                        // },
                        // { validator: validateInput },

                        // () => ({
                        //   validator(rule, value = "") {
                        //     if (value.substring(1, 0) === " ") {
                        //       return Promise.reject("Invalid Office area");
                        //     } else {
                        //       return Promise.resolve();
                        //     }
                        //   },
                        // }),
                      ]}
                    >
                      <Input placeholder="0" type="text" maxLength={20} />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} md={md} sm={sm} xs={xs}>
                    <Form.Item
                      name="staff"
                      label={"No. of staff"}
                      onKeyPress={(event) => {
                        if (
                          checkNumbervalue(event) ||
                          checkSpecialCharacter(event) ||
                          checkSpace(event)
                        ) {
                          event.preventDefault();
                        }
                      }}
                      rules={[
                        {
                          required: true,
                          message: "Please select value",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter number of staff"
                        type="text"
                        maxLength={3}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={lg} md={md} sm={sm} xs={xs}>
                    <Form.Item
                      name="checkVehicleAvailability"
                      label={
                        <span className="calculater-container-pikpin">
                          If CP owns vehicle for First mile delivery?
                        </span>
                      }
                    >
                      <Radio.Group
                        style={radioGap}
                        onChange={(e) =>
                          setOwnVehicle(JSON.parse(e.target.value))
                        }
                        defaultValue={false}
                        // value={isMiniHub}
                        rules={[
                          {
                            required: true,
                            message: "Please select value",
                          },
                        ]}
                      >
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {ownVehicle && (
                    <>
                      <Col lg={lg} md={md} sm={sm} xs={xs}>
                        <Form.Item
                          name="numberOfVehicles"
                          label={"No. of Vehicle"}
                          onKeyPress={(event) => {
                            if (
                              checkNumbervalue(event) ||
                              checkSpecialCharacter(event) ||
                              checkSpace(event)
                            ) {
                              event.preventDefault();
                            }
                          }}
                          rules={[
                            {
                              required: true,
                              message: "Please select value",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Enter number of vehicle"
                            type="text"
                            maxLength={2}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </FormComponent>
            </div>
          </div>
        </div>

        <div className="button-container1">
          <div className="steps-action">
            <Button className="back-button" onClick={() => backPage()}>
              {"BACK"}
            </Button>

            <Button
              htmlType="submit"
              className="next-button"
              form="MiscellaneousDetails"
              key="submit"
            >
              {"SUBMIT"}
            </Button>
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default MiscellaneousDetails;
